export default __webpack_public_path__ + "static/media/032-bell.01f7ebaf.png";